import React from 'react';
import {Link} from 'react-router-dom';
import { getLinkWithQueryParams } from '../../utils/getLinkWithQueryParams';

const AppLink = (props) => {
  return <Link {...props} to={getLinkWithQueryParams(props.to)} />;
};

export default AppLink;
